import { Component, h, Prop, EventEmitter, Event, Element } from '@stencil/core';

@Component({
  tag: 'signet-button-group',
  styleUrl: 'signet-button-group.scss',
  // shadow: true,
})
export class SignetButtonGroup {
  /**
   * The current value of the button group
   */
  @Prop({ mutable: true }) value: string;
  /**
   * An event emitted when the value of the button group changes.
   */
  @Event() valueChange: EventEmitter<string>;

  @Element() el!: HTMLElement;

  handleClick(buttonValue: string) {
    this.value = buttonValue;
    this.valueChange.emit(this.value);
    // Vue 2: emit 'input' event
    this.el.dispatchEvent(new CustomEvent('input', {
      bubbles: true,
      composed: true,
      detail: this.value,
    }));

    // Vue 3: emit 'update:modelValue' event
    this.el.dispatchEvent(new CustomEvent('update:modelValue', {
      bubbles: true,
      composed: true,
      detail: this.value,
    }));
  }

  render() {
    return (
      <div class="signet-button-group">
        <slot></slot>
      </div>
    );
  }
}
